var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.225,
    height: 18.322,
    viewBox: "0 0 19.225 18.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#ec5867;stroke-miterlimit:10;stroke-width:1.5px;}.b{fill:rgba(236,88,103,0.26);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.542)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M947.5,523.822l1.672-6.239.542-2.235L951.737,507h3.794l1.926,8.348.472,2.046,1.522,6.428Z",
    transform: "translate(-947.5 -507)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M955.129,540.5h7.589l.506,2.024-8.474-.126Z",
    transform: "translate(-949.375 -532.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M959.006,522.5h5.565l.506,2.024H958.5Z",
    transform: "translate(-952.176 -518.579)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 19.225,
    transform: "translate(0 16.822)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/Icon_error.a69345c8dad3907e9d19ca283f42f829.svg";
export { ForwardRef as ReactComponent };